import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { Alert } from 'react-daisyui';
import { useRollbar } from '@rollbar/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
  message?: string;
  description?: string;
  isSuperAdmin?: boolean;
  error?: unknown;
  context?: string;
}
export default function ErrorAlert({
  message = `There was a problem loading the page`,
  description = `Please try refreshing the page, if the error persists contact the system's administrator.`,
  isSuperAdmin = false,
  error,
  context,
}: Props) {
  const rollbar = useRollbar();
  const { pathname } = useLocation();

  useEffect(() => {
    if (error && rollbar) {
      // rollbar.error(
      //   `Error logged in ErrorAlert - page: ${pathname}${context ? ` - context: ${context}` : ''} - ${message} - ${description} - ${JSON.stringify(
      //     error as Error
      //   )}`,
      //   {
      //     error,
      //     page: pathname,
      //     ...(context && { context }),
      //   }
      // );
      rollbar.error(
        `Error logged in ErrorAlert - page: ${pathname}${
          context ? ` - context: ${context}` : ''
        } - ${message} - ${description}`,
        error instanceof Error ? error : new Error(String(error)),
        { page: pathname, context, message, description }
      );
    }
  }, [error, message, description, rollbar, pathname, context]);

  return (
    <Alert
      // eslint-disable-next-line max-len
      className='rounded-2xl opacity-80  w-[80%] text-sm transition-opacity duration-500 mx-auto my-8'
      icon={<FontAwesomeIcon icon={faTimesCircle} size='2x' />}
      status='error'
    >
      <div>
        <h2 className='text-lg font-bold'>{message}</h2>
        {description && <h3 className='text-base'>{description}</h3>}
        {isSuperAdmin && (
          <>
            <h4 className='text-base'>Page: {pathname}</h4>
            {context && <h4 className='text-base'>Context: {context}</h4>}
            {error && (
              <h4 className='text-base'>
                Error: {JSON.stringify(error, null, 2)}
              </h4>
            )}
          </>
        )}
      </div>
    </Alert>
  );
}
